import type {
  GuideTourDefinition,
  GuideTourRuntimeState,
  GuideTourStep,
} from './types'
import {
  hasGuideTourStepAfter,
  hasGuideTourStepBefore,
} from './utils/tourRuntime'

export { createInitialGuideTourState } from './stateInitial'
export { applyGuideTourReducerAction as guideTourReducer } from './guideTourReducerActions'

export const getGuideTourStepCount = (
  tour: GuideTourDefinition | null
): number => tour?.steps.length ?? 0

export const getCurrentGuideTourStep = (
  state: GuideTourRuntimeState
): GuideTourStep | null => {
  if (!state.activeTour) {
    return null
  }

  return state.activeTour.steps[state.currentStepIndex] ?? null
}

export const isGuideTourFirstStep = (state: GuideTourRuntimeState): boolean => {
  if (!state.activeTour) {
    return true
  }

  return !hasGuideTourStepBefore(state.activeTour, state.currentStepIndex)
}

export const isGuideTourLastStep = (state: GuideTourRuntimeState): boolean => {
  if (!state.activeTour) {
    return false
  }

  return !hasGuideTourStepAfter(state.activeTour, state.currentStepIndex)
}

export const shouldGuideTourCompleteOnNext = (
  state: GuideTourRuntimeState
): boolean => isGuideTourLastStep(state)

export const canGoToNextGuideTourStep = (
  state: GuideTourRuntimeState
): boolean => {
  if (state.status !== 'active' || !state.activeTour) {
    return false
  }

  return hasGuideTourStepAfter(state.activeTour, state.currentStepIndex)
}

export const canGoToPrevGuideTourStep = (
  state: GuideTourRuntimeState
): boolean => {
  if (state.status !== 'active' || !state.activeTour) {
    return false
  }

  return hasGuideTourStepBefore(state.activeTour, state.currentStepIndex)
}
